import { render } from "./CardsComponent.vue?vue&type=template&id=634c8a9d&scoped=true"
import script from "./CardsComponent.vue?vue&type=script&lang=js"
export * from "./CardsComponent.vue?vue&type=script&lang=js"

import "./CardsComponent.vue?vue&type=style&index=0&id=634c8a9d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-634c8a9d"]])

export default __exports__